const getters = {
  getCampaignMaster(state) {
    return state.campaignMaster;
  },
  getCustomerMaster(state) {
    return state.customerMaster;
  },
  getReportsNERP(state) {
    return state.reports;
  },
  getPurpose(state) {
    return state.purposeType;
  },
  getNerpCampingMaster(state) {
    return state.nerpCampingMaster;
  },
  getProductTypeCampaign(state) {
    return state.getProductTypeCampaign;
  },
};

export default getters;